export const meetingsSettingsPath = '/events-and-meetings/settings';
export const ANALYTICS_CATEGORY = 'schedule-meeting';
